import React from 'react'

interface IProps {
  count: number
}

const Info: React.FC<IProps> = props => {
  const { count } = props

  return (
    <div className="w-full h-30 pb-10 mb-25 font-500 text-13 text-black tracking-0.1 border-b-1 border-black">
      <p>
        {count} {count === 1 ? 'Ergebnis' : 'Ergebnisse'}
      </p>
    </div>
  )
}

export default Info
